import NotebookPageContentBlockTypeButton from "atoms/buttons/notebook-page-content-block-button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { HeadingPriority } from "atoms/constants/heading-priority";
import Heading from "atoms/typography/heading";
import Paragraph from "atoms/typography/paragraph";
import { NotebookPageContentBlock } from "constants/notebooks/notebook-page-content-blocks";
import React from "react";
import { HideIfReadonly } from "utilities/contexts/readonly/hide-if-readonly";
import { t } from "utilities/localization-utils";

interface AddPageBlockProps {
    onAddContent: (type: any) => Promise<void>;
}

const CSS_CLASS_NAME = "c-add-page-block";

const AddPageBlock = ({ onAddContent }: AddPageBlockProps) => {
    /* Separate out as own component? Or, generate this list automatically once we determined permissions per block, if any */
    const ContentBlockList = ({
        buttonStyle = ButtonStyles.None,
    }: {
        buttonStyle?: ButtonStyles;
    }) => (
        // Render by iterating over enum on we're no longer disabling these manually
        <ul className={`${CSS_CLASS_NAME}__blockList`}>
            <li className={`${CSS_CLASS_NAME}__blockListItem`}>
                <NotebookPageContentBlockTypeButton
                    onClick={handleAddContent}
                    type={NotebookPageContentBlock.Text}
                    style={buttonStyle}
                />
            </li>
            <li className={`${CSS_CLASS_NAME}__blockListItem`}>
                <NotebookPageContentBlockTypeButton
                    onClick={handleAddContent}
                    type={NotebookPageContentBlock.CodeReference}
                    style={buttonStyle}
                />
            </li>
            <li className={`${CSS_CLASS_NAME}__blockListItem`}>
                <NotebookPageContentBlockTypeButton
                    onClick={handleAddContent}
                    type={NotebookPageContentBlock.Checklist}
                    style={buttonStyle}
                />
            </li>
            <li className={`${CSS_CLASS_NAME}__blockListItem`}>
                <NotebookPageContentBlockTypeButton
                    onClick={handleAddContent}
                    type={NotebookPageContentBlock.Image}
                    style={buttonStyle}
                />
            </li>
        </ul>
    );

    const handleAddContent = async (type: NotebookPageContentBlock) => {
        await onAddContent(type);
    };

    return (
        <HideIfReadonly>
            <section className={CSS_CLASS_NAME}>
                <div className={`${CSS_CLASS_NAME}__main`}>
                    <div className={`${CSS_CLASS_NAME}__header`}>
                        <Heading
                            priority={HeadingPriority.Three}
                            cssClassName={`${CSS_CLASS_NAME}__title`}>
                            {t("noBlocksAdded--heading")}
                        </Heading>
                        <div className={`${CSS_CLASS_NAME}__text`}>
                            <Paragraph
                                cssClassName={`${CSS_CLASS_NAME}__subheading`}>
                                {t("noBlocksAdded--helpText")}
                            </Paragraph>
                        </div>
                    </div>
                    <div className={`${CSS_CLASS_NAME}__container`}>
                        <ContentBlockList />
                    </div>
                </div>
            </section>
        </HideIfReadonly>
    );
};

export default AddPageBlock;
